module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (211).39c18cfe.jpg";